import React from 'react';
import DOMPurify from 'dompurify';
import _get from 'lodash/get';

export default function DescriptionContent({
  activeDetection,
  detectionMapping,
  isShowSkinAge,
  detectionDescriptionContent,
  activeLang,
}) {
  return (
    <div className="skincaredetectionpreview-results__description">
      {activeDetection === 'skin_health' && isShowSkinAge && (
        <>
          <div className="skincaredetectionpreview-results__description-title">
            {detectionMapping['skin_age'].label}
          </div>
          <div className="skincaredetectionpreview-results__description-content">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  _get(detectionDescriptionContent, `${activeLang}.skin_age`) &&
                    _get(detectionDescriptionContent, `${activeLang}.skin_age`)
                      .replace(/\n/g, '<br/>')
                      .replace(/ /g, '&nbsp')
                ),
              }}
            />
          </div>
        </>
      )}
      <div className="skincaredetectionpreview-results__description-title">
        {_get(
          detectionMapping,
          `${activeDetection}.labelI18n.${activeLang}`
        ) || {...detectionMapping[activeDetection].label}}
      </div>
      <div className="skincaredetectionpreview-results__description-content">
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              _get(
                detectionDescriptionContent,
                `${activeLang}.${activeDetection}`,
                ''
              )
                .replace(/\n/g, '<br/>')
                .replace(/ /g, '&nbsp')
            ),
          }}
        />
      </div>
    </div>
  );
}
